import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import Status from "./Status";
import { displayCreatedAt } from "utils/helpers";

export const questionsColumns = [
  {
    label: "Ref ID",
    field: "id",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ id }) => (
      <TextFieldWithEllipsis>{String(id).slice(0, 8)}...</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Created At",
    field: "createdAt",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: displayCreatedAt,
  },
  // {
  //   label: "Type",
  //   field: "type",
  //   xs: 1.25,
  //   sm: 1.25,
  //   md: 1.25,
  //   renderer: ({ type }) => (
  //     <TextFieldWithEllipsis>{type}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Type",
  //   xs: 0.75,
  //   sm: 0.75,
  //   md: 0.75,
  //   renderer: ({ buttonType }) => (
  //     <TextFieldWithEllipsis>
  //       {convertDeviceType(buttonType)}
  //     </TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Provider",
    field: "provider",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ providers }) => (
      <TextFieldWithEllipsis>{providers}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ originatorName }) => (
      <TextFieldWithEllipsis>{originatorName}</TextFieldWithEllipsis>
    ),
  },
  // {
  //   label: "Phone",
  //   field: "originatorPhone",
  //   xs: 1.25,
  //   sm: 1.25,
  //   md: 1.25,
  //   renderer: ({ originatorPhone }) => (
  //     <TextFieldWithEllipsis>{originatorPhone}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Email",
  //   field: "originatorEmail",
  //   xs: 1.5,
  //   sm: 1.5,
  //   md: 1.5,
  //   renderer: ({ originatorEmail }) => (
  //     <TextFieldWithEllipsis>{originatorEmail}</TextFieldWithEllipsis>
  //   ),
  // },
//   {
//     label: "Patient",
//     field: "patientName",
//     xs: 1.5,
//     sm: 1.5,
//     md: 1.5,
//     renderer: ({ patientName }) => (
//       <TextFieldWithEllipsis>{patientName}</TextFieldWithEllipsis>
//     ),
//   },
//   {
//     label: "DOB",
//     field: "patientDob",
//     xs: 1,
//     sm: 1,
//     md: 1,
//     renderer: ({ patientDob }) => {
//       if (!patientDob) return "";
//       const date = new Date(patientDob);
//       return new Intl.DateTimeFormat("en-US", {
//         dateStyle: "short",
//       }).format(date);
//     },
//   },
  {
    label: "Question",
    field: "question",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: ({ question }) => (
      <TextFieldWithEllipsis>{question}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "recipientName",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: ({ recipientName }) => (
      <TextFieldWithEllipsis>{recipientName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Specialists",
    field: "specialists",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ specialists }) => (
      <TextFieldWithEllipsis>{specialists}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ status }) => <Status value={status} />,

  },
];

export const questionsMobileColumns = [
    // {
    //   label: "Ref ID",
    //   field: "id",
    //   xs: 2.5,
    //   sm: 2.5,
    //   md: 2.5,
    //   renderer: ({ id }) => (
    //     <TextFieldWithEllipsis>{String(id).slice(0, 8)}...</TextFieldWithEllipsis>
    //   ),
    // },
    {
      label: "Created",
      field: "createdAt",
      xs: 4,
      sm: 4,
      md: 4,
      renderer: displayCreatedAt,
    },
    // {
    //   label: "Type",
    //   xs: 2.5,
    //   sm: 2.5,
    //   md: 2.5,
    //   renderer: ({ buttonType }) => (
    //     <TextFieldWithEllipsis>
    //       {convertDeviceType(buttonType)}
    //     </TextFieldWithEllipsis>
    //   ),
    // },
    {
      label: "Sender",
      field: "originatorName",
      xs: 2,
      sm: 2,
      md: 2,
      renderer: ({ originatorName }) => (
        <TextFieldWithEllipsis>{originatorName}</TextFieldWithEllipsis>
      ),
    },
    {
      label: "Question",
      field: "question",
      xs: 2,
      sm: 2,
      md: 2,
      renderer: ({ question }) => (
        <TextFieldWithEllipsis>{question}</TextFieldWithEllipsis>
      ),
    },
    {
      label: "Recipient",
      field: "recipientName",
      xs: 2,
      sm: 2,
      md: 2,
      renderer: ({ recipientName }) => (
        <TextFieldWithEllipsis>{recipientName}</TextFieldWithEllipsis>
      ),
    },
    {
      label: "Status",
      field: "status",
      xs: 2,
      sm: 2,
      md: 2,
      renderer: ({ status }) => <Status value={status} />,
  
    },
  ];
  